import { ReportHistory } from './../models/report-history';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Report } from 'app/models/report';

import { ConfigData } from '../app.config';
import { Type } from 'app/models/index';

@Injectable({
  providedIn: 'root'
})
export class ReportService {
  reportUrl = `${ConfigData.apiUrl}/report`;

  constructor(private http: HttpClient) { }

  // Restituisce i codici e le descrizioni dei report disponibili da poter generare
  getReportList(): Observable<Type[]> {
    return this.http.get<Type[]>(`${this.reportUrl}/listCode`);
  }

  /**
   * Restituisce tutti i possibili site (o raccolte) per cui sarà possibile filtrare la generazione dei report.
   */
  getReportSite(): Observable<Type[]> {
    return this.http.get<Type[]>(`${this.reportUrl}/listSite`);
  }

  // Restituisce un oggetto JSON con dei dati richiesti a seconda del codice passato
  getReport(codiceReport: string, req: Report): Observable<any> {
    return this.http.post<any>(`${this.reportUrl}/${codiceReport}`, req);
  }

  // Restituisce un file .csv con i dati richiesti a seconda del codice passato
  downloadReportCSV(codiceReport: string, req: any): Observable<any> {
    const obj = {
      title: req.title,
      site: req.site,
      exactDate: req.exactDate,
      start: req.start,
      end: req.end,
      excludeTerms: req.excludeTerms
    };
    const httpOptions = {
      responseType: 'blob' as 'json'
    };
    return this.http.post<any>(
      `${this.reportUrl}/print/csv/${codiceReport}`,
      obj,
      httpOptions
    );
  }

  // Restituisce un file .pdf con i dati richiesti a seconda del codice passato
  downloadReportPDF(codiceReport: string, req: Report): Observable<any> {
    const obj = {
      title: req.title,
      exactDate: req.exactDate,
      start: req.start,
      end: req.end,
      site: req.site,
      excludeTerms: req.excludeTerms
    };
    const httpOptions = {
      responseType: 'blob' as 'json'
    };
    return this.http.post<any>(
      `${this.reportUrl}/print/pdf/${codiceReport}`,
      obj,
      httpOptions
    );
  }

  saveReportForHistory(exportMediaType: string, reportCode: string, report: Report): Observable<any> {
    return this.http.post<any>(
      `${this.reportUrl}/save/${exportMediaType}/${reportCode}`, report
    )
  }

  getReportsHistory(): Observable<ReportHistory[]> {
    return this.http.get<ReportHistory[]>(
      `${this.reportUrl}/history`
    );
  }

  downloadHistoryReport(idReport: number): Observable<any> {
    const httpOptions = {
      responseType: 'blob' as 'json'
    };

    return this.http.get(`${this.reportUrl}/history/download/${idReport}`, httpOptions);
  }

  deleteHistoryReport(idReport: number): Observable<boolean> {
    return this.http.delete<boolean>(`${this.reportUrl}/history/${idReport}`);
  }
}
